import { useState, useCallback } from 'react';

export const useHeightRef = (defaultHeight = 0) => {
	const [height, setHeight] = useState(defaultHeight);
	const ref = useCallback((node: any) => {
		node && setHeight(node.clientHeight);
	}, []);
	return { height, ref };
};
